import { graphql } from 'gatsby';
import React from 'react';
import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';
import HeroInlineProgressiveForm from 'components/Form/ProgressiveForm/HeroInlineProgressiveForm';
import ContentfulDynamicHero from 'components/Contentful/ContentfulDynamicHero';
import BlogCardGroupSection from 'components/Sections/ImageCardSections/BlogCardGroupSection';
import DemoFormSection from 'components/Sections/DemoFormSection';
import ToolboxLayout from 'layouts/toolboxLayout';
import getBreakpointView from 'utils/getBreakpointView';

const BlogTemplate = props => {
  const allPosts = props.data.allPosts.edges.map(x => x.node);
  const hubType = 'blog';
  const seo = props.data.contentfulSeo;
  const dynamicHero = props.data.contentfulDynamicHero;
  const isMobile = getBreakpointView(['xs']);

  const breadcrumbs = {
    data: [
      {
        title: 'Toolbox',
        icon: null,
        url: '/toolbox',
      },
      !isMobile && {
        title: 'Blog',
        icon: null,
        url: null,
      },
    ],
  };

  return (
    <ToolboxLayout breadcrumbs={breadcrumbs} contentfulSeo={seo} {...props}>
      <BlogContent>
        <SectionLayout className="blog-content--layout" backgroundColor="white" contentBelowSection>
          <BlogDynamicHero
            {...dynamicHero}
            images={[]}
            customInlineForm={<HeroInlineProgressiveForm buttonColor="secondary" theme="light" />}
          />
          <BlogCardGroupSection
            allContent={allPosts}
            hubType={hubType}
            industries={props.pageContext.industries}
            topics={props.pageContext.topics}
          />
        </SectionLayout>
        <DemoFormSection
          backgroundColor="Bright Blue"
          formTitle="Let’s get started."
          description="Explore why 100,000+ contractors trust Service Titan to run their business."
          title="Book a personalized demo today."
        />
      </BlogContent>
    </ToolboxLayout>
  );
};

export default BlogTemplate;

export const pageQuery = graphql`
  query BlogTemplateQuery($allPosts: [String!]) {
    contentfulDynamicHero(internalName: { eq: "Dynamic Hero - Blog" }) {
      ...DynamicHero
    }
    contentfulSeo(internalName: { eq: "Blog" }) {
      ...Seo
    }
    site {
      siteMetadata {
        title
      }
    }
    allPosts: allContentfulBlog(
      filter: { contentful_id: { in: $allPosts } }
      sort: { order: DESC, fields: publishDate }
    ) {
      edges {
        node {
          id
          title
          seo {
            ...Seo
          }
          excerpt {
            excerpt
          }
          featuredImage {
            title
            description
            fluid(quality: 100) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
          publishDate(formatString: "MMMM Do, YYYY")
          publishDateRaw: publishDate
          taxonomy {
            ...Taxonomy
          }
        }
      }
    }
  }
`;

const BlogDynamicHero = styled(ContentfulDynamicHero)`
  padding-top: 70px;

  .hero-copy {
    .hero-copy-description {
      font-size: 25px;
      margin: 50px auto 0px;
      padding: 0px 28px;
      color: var(--neutral-6);
      line-height: 28px;
    }
  }

  @media (max-width: 768px) {
    padding-top: 40px;
    .section-layout--inner-container {
      padding: 60px 0px 28px;
    }
    .hero-copy {
      margin-bottom: 0;
      .hero-copy-description {
        margin-top: 20px;
        font-size: 20px;
        padding: 0px;
      }
    }
  }
`;

const BlogContent = styled.div`
  font-family: Sofia Pro;

  .blog-content--layout .section-layout--inner-container {
    padding-top: 0;
  }

  .section-blog-details-legal-info {
    opacity: 1;
    width: 500px;
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
    margin: 0 auto -70px auto;
    color: var(--black-color);
  }

  .section-blog-details-submit-legal-info {
    opacity: 1;
    width: 500px;
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    text-align: center;
    margin: 0 auto -70px auto;
    color: var(--green-5);
  }

  @media (max-width: 767px) {
    .section-blog-details-legal-info {
      width: 100%;
      margin: 0 auto -89px auto;
    }
  }
`;
